import { SvgIconProps } from "@mui/material";

export const RotateZAxis = (props: SvgIconProps) => {
    return (
        <svg
            fill="#838280"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M6.34234829,5 L3.5,5 C3.22385763,5 3,4.77614237 3,4.5 C3,4.22385763 3.22385763,4 3.5,4 L7.5,4 C7.77614237,4 8,4.22385763 8,4.5 L8,8.5 C8,8.77614237 7.77614237,9 7.5,9 C7.22385763,9 7,8.77614237 7,8.5 L7,5.754353 C5.12534543,7.25566058 4,9.53220768 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.75561002 16.684877,4.25604977 12.4672193,4.01340168 C12.1915328,3.99754103 11.9809023,3.76119536 11.996763,3.48550885 C12.0126236,3.20982234 12.2489693,2.99919187 12.5246558,3.01505252 C17.2706793,3.28809828 21,7.22490011 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,9.23851765 4.2535362,6.68868786 6.34234829,5 Z" />
        </svg>
    );
};
